import type { BootstrapResponse, LoginInput, LoginResponse } from '@ruby/shared';
import { api, refreshAccessToken } from './api';
import { queryClient } from './query';
import { useSession } from './session';

export async function loadBootstrap() {
  const boot = await api<BootstrapResponse>('/me/bootstrap');
  useSession.getState().setBoot(boot);
  return boot;
}

/** On app start: resume the session from the refresh cookie, if any. */
export async function resumeSession() {
  if (await refreshAccessToken()) {
    try {
      await loadBootstrap();
      return;
    } catch {
      /* fall through */
    }
  }
  useSession.getState().signedOut();
}

export async function login(input: LoginInput) {
  const res = await api<LoginResponse>('/auth/login', { method: 'POST', body: input });
  useSession.getState().setToken(res.accessToken);
  return loadBootstrap();
}

export async function logout() {
  try {
    await api('/auth/logout', { method: 'POST' });
  } finally {
    queryClient.clear();
    useSession.getState().signedOut();
  }
}
